import { render, staticRenderFns } from "./DevicesEmissionsFactors.vue?vue&type=template&id=15913a1f&scoped=true"
import script from "./DevicesEmissionsFactors.vue?vue&type=script&lang=js"
export * from "./DevicesEmissionsFactors.vue?vue&type=script&lang=js"
import style0 from "./DevicesEmissionsFactors.vue?vue&type=style&index=0&id=15913a1f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15913a1f",
  null
  
)

export default component.exports